var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMegaphoneLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9167 24.6382L84.75 9.87633V71.4554L58.9167 56.6935V24.6382ZM54.4167 25.5825V55.7492H45.6212L45.6212 55.749H23.7422L23.7422 55.7492H21C15.6152 55.7492 11.25 51.384 11.25 45.9992V35.3325C11.25 29.9477 15.6152 25.5825 21 25.5825H54.4167ZM24.3851 60.2492H21C13.1299 60.2492 6.75 53.8692 6.75 45.9992V35.3325C6.75 27.4625 13.1299 21.0825 21 21.0825H56.0691L83.1906 5.58452C85.8906 4.04169 89.25 5.99122 89.25 9.10091V72.2308C89.25 75.3405 85.8906 77.29 83.1906 75.7472L56.0691 60.2492H46.2641L49.2522 81.1656C49.9622 86.1357 46.1056 90.5824 41.0851 90.5824H35.8736C31.768 90.5824 28.2871 87.5635 27.7065 83.4991L24.3851 60.2492ZM28.9308 60.2492L32.1613 82.8627C32.4252 84.7101 34.0074 86.0824 35.8736 86.0824H41.0851C43.3671 86.0824 45.1201 84.0612 44.7974 81.802L41.7184 60.2492H28.9308Z",
    fill: "url(#paint0_linear_601_7223)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_601_7223",
    x1: 89.25,
    y1: 90.5823,
    x2: 6.75,
    y2: 90.5823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACAAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMegaphoneLined);
export default __webpack_public_path__ + "static/media/ic_megaphone_lined.954c50379ca1facf5d6ececc453b9dc3.svg";
export { ForwardRef as ReactComponent };